export class Payout {
  customer_rate: number;
  rate: number;
  type: string;
  currency: string;
  amount: number;
  partner_id: string;
  branch_code: string;
  bank_account: string;
  bank_code: string;
  bank_name: string;
  country: string;
  partner_name: string;
  branch_name: string;
  partner_code: string;

  static CloneForCreateTranaction(payout: Payout, validation?: boolean) {
    const clone = new Payout();
    clone.partner_id = payout.partner_id
    clone.bank_account = payout.bank_account
    clone.type = payout.type
    clone.currency = payout.currency
    if (payout.amount) {
      clone.amount = payout.amount
    }
    if (!validation) {
      clone.bank_code = payout.bank_code
      clone.branch_code = payout.branch_code
      clone.customer_rate = payout.customer_rate
      clone.rate = payout.rate
    }
    return clone;
  }
}

export const PayoutType = {
  'AccountDeposit': 'Account deposit',
  // 'AccountDepositOtherBank': 'Account deposit to Other Bank',
  'AliPay': 'AliPay',
  'Cash': 'Cash Payment',
  'CardCredits': 'Credit Card',
  'E_Wallet': 'E-Wallet',
  'HomeDelivery': 'HomeDelivery',
  'Mobile': 'Mobile',
  'RDA' : 'Roshan Digital Account Deposit'
};


export class PayoutTypeValues {
  list = PayoutType;
  getList(): Array<string> {
    return Object.keys(this.list);
  }
}


// WEBPACK FOOTER //
// ./src/app/model/shared/transaction/payout.ts